/*******************************************************************************
 * Copyright (c) 2024 Malond Limited. All rights reserved.
 * The source code is the property of Malond Limited.
 * The source code may not be shared with third parties without the express consent of Malond Limited.
 * THE CONTENTS OF THIS PROJECT ARE PROPRIETARY AND CONFIDENTIAL.
 * UNAUTHORIZED COPYING, TRANSFERRING OR REPRODUCTION OF THE CONTENTS OF THIS PROJECT,
 * VIA ANY MEDIUM IS STRICTLY PROHIBITED.
 * The receipt or possession of the source code and/or any parts thereof does not convey or imply
 * any right to use them for any purpose other than the purpose for which they were provided to you.
 * The source code is provided as is.
 * Any changes made to the files must be tracked.
 * Malond Limited does not claim ownership of any changes made to the code.
 ******************************************************************************/

import numeral from "numeral"

// Libs
export interface APIMeta {
  limit?: number
  offset?: number
  total?: number
}

export interface PaginationProps {
  limit: number
  offset: number
}

export function getCurrentPageFromMeta({
  limit,
  offset,
  total,
}: APIMeta): number {
  if (!offset || !total) {
    return 1
  }

  const offsetNumeral = numeral(offset).value() || 0
  const totalNumeral = numeral(total).value() || 0

  if (!offsetNumeral || offsetNumeral === 0) {
    return 1
  }

  // Not found total => Broken: it's just 1 page
  if (!totalNumeral || totalNumeral === 0) {
    return 1
  }

  // Broken: offset > total
  if (offsetNumeral > totalNumeral) {
    return -1
  }

  const limitNumeral = numeral(limit).value() || 0

  const pageNumeral = Math.floor(offsetNumeral / limitNumeral + 1) || 0

  return pageNumeral
}

export function getMetaFromPagination(
  page: number,
  pageSize: number
): PaginationProps {
  return {
    limit: numeral(pageSize).value() || 0,
    offset:
      page > 0 ? numeral(page).subtract(1).multiply(pageSize).value() || 0 : 0,
  }
}
